import { render, staticRenderFns } from "./OwalPanelHeader.vue?vue&type=template&id=6f777f35&scoped=true"
import script from "./OwalPanelHeader.vue?vue&type=script&lang=js"
export * from "./OwalPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./OwalPanelHeader.vue?vue&type=style&index=0&id=6f777f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f777f35",
  null
  
)

export default component.exports